export default (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            width="9.49046"
            height="9.49046"
            rx="2"
            transform="matrix(0.682348 0.731027 -0.682348 0.731027 6.47653 -0.437988)"
            fill="#1522B0"
        />
    </svg>
)
